import React from 'react';
import PropTypes from 'prop-types';
import { Label, Spinner, Wrapper } from './styles';

const LoadingIndicator = ({ loading, label, children, ...props }) => {
	if (loading) {
		return (
			<Wrapper {...props}>
				<Spinner />
				<Label>{label}</Label>
			</Wrapper>
		);
	}
	return children ? children() : null;
};

LoadingIndicator.propTypes = {
	loading: PropTypes.bool,
	label: PropTypes.node,
	children: PropTypes.func,
};

LoadingIndicator.defaultProps = {
	label: 'Loading...',
};

export default LoadingIndicator;
